import { useState, useEffect } from "react";
import io from "socket.io-client";

function useSocket(interviewData) {
  // let ioUrl = 'https://socket-ai-interview.dev.hireplusplus.com/';
  // if (window.location.hostname && window.location.hostname.includes("interview-v2.hireplusplus.com")) {
  //     ioUrl = "https://socket-ai-interview.hireplusplus.com/";
  // }
  let ioUrl;

  if (window.location.hostname === "localhost") {
    // ioUrl = "http://localhost:8080";
    ioUrl = "https://socket-ai-interview.dev.hireplusplus.com/";
  } else if (
    // window.location.hostname.includes(
    //   "ai-interview.dev.hireplusplus.com" || "kelsa.dev.hireplusplus.com"
    // )
    window.location.hostname.includes("dev.hireplusplus.com")
  ) {
    ioUrl = "https://socket-ai-interview.dev.hireplusplus.com/";
  } else {
    ioUrl = "https://socket-ai-interview.hireplusplus.com/";
  }

  const [socket, setSocket] = useState(null);

  useEffect(() => {
    let socketInstance = null;
    if (interviewData) {
      socketInstance = io(ioUrl, {
        auth: {
          token: interviewData?.passcode,
          interviewData,
        },
        transports: ["websocket"],
        reconnectionAttempts: 2, // Limit the number of reconnection attempts
        reconnectionDelay: 1000, // Initial delay of 1 second between attempts
        reconnectionDelayMax: 2000, // Maximum delay of 3 seconds between attempts
      });
      setSocket(socketInstance);
    }

    return () => {
      socketInstance?.disconnect();
    };
  }, [ioUrl, interviewData]);

  return [socket, setSocket];
}

export default useSocket;
